<template>
  <a-locale-provider :locale="locale">
    <div id="orderPassenger" class="page-passenger">
      <l8-cart v-if="cart" ref="cart" :id="cart.shoppingCartId" :isJJC="isSpecial" :value="cart"></l8-cart>
      <div class="container pt-40">
        <a-form :form="form" layout="vertical">
          <div id="passenger-list">
            <div class="mod">
              <div class="usual-passenger passenger-module passenger-form-row" v-if="!isSpecial">
                <div class="usual-psg-title">
                  <h3>常用乘机人</h3>
                </div>
                <div class="usual-psg-content">
                  <div class="usual-psg-list">
                    <a-checkbox-group
                      :options="usualPassengerCheckList"
                      :value="usualPassenger"
                      @change="selectUsual"
                    />
                  </div>
                </div>
              </div>
              <!--军警残乘机人表单-->
              <div class="passenger-special-info" v-if="isSpecial">
                <div class="passenger-module">
                  <special-passenger :specialType="specialType" @inputItemValide="inputItemValide"></special-passenger>
                </div>
              </div>
              <!--普通乘机人信息列表表单-->
              <div class="passenger-info-list mt-20" v-if="!isSpecial">
                <div class="passenger-module" v-for="(psg, index) in forFormList" :key="psg.key">
                  <template v-if="!ifInternational">
                    <passenger-item
                      :initValue="psg"
                      :psgIndex="index"
                      :adultList="adultList"
                      :isDisabledChangeBirthday="isDisabledChangeBirthday(index)"
                      :oriDataList="oriDataList"
                      :departureDate="departureDate"
                      :passengerFieldInfo="passengerFieldInfo"
                      :passengerTypeInfo="passengerTypeInfo"
                      :ifInviteRegisterFfp="ifInviteRegisterFfp"
                      @setUsual="setUsual"
                      @setInvite="setInvite"
                      @removePassenger="removePassenger"
                      @inputItemValide="inputItemValide"
                      @getAdultList="getAdultList"
                      @idTypeChange="onIdTypeChange"
                      @setFullName="setFullName"
                    ></passenger-item>
                  </template>
                  <template v-else>
                    <passenger-item-int
                      :initValue="psg"
                      :psgIndex="index"
                      :adultList="adultList"
                      :oriDataList="oriDataList"
                      :departureDate="departureDate"
                      :dictionaryList="dictionaryList"
                      :passengerFieldInfo="passengerFieldInfo"
                      :passengerTypeInfo="passengerTypeInfo"
                      :isNorthAmericaSegment="isNorthAmericaSegment"
                      @setUsual="setUsual"
                      @setFullName="setFullName"
                      @inputItemValide="inputItemValide"
                      @getAdultList="getAdultList"
                    ></passenger-item-int>
                  </template>

                </div>
              </div>
              <div class="passenger-add" v-if="!isSpecial && !ifInternational">
                <span class="passenger-btn-box">
                  <a-button type="primary" size="default" @click="addPassenger('ADT')">成人+1</a-button>
                </span>
                <span class="passenger-btn-box">
                  <a-button type="primary" size="default" @click="addPassenger('CHD')">儿童+1</a-button>
                </span>
                <span class="passenger-btn-box">
                  <a-button type="primary" size="default" @click="addPassenger('INF')">婴儿+1</a-button>
                </span>
              </div>
            </div>
            <div class="mod mt-20 special-passenger-upload" v-if="isSpecial && enableUploadJjcCert">
              <h3 class="special-upload-title_popover">
                <div>上传军警残证件</div>
                <a-popover title="证件示例" v-if="soldierExampleList.length || policeExampleList.length">
                  <template slot="content">
                    <div class="tab-box">
                      <a-tabs :default-active-key="activeKey">
                        <a-tab-pane key="1" tab="伤残军人证" v-if="soldierExampleList.length">
                          <div class="example-popover">
                            <div class="example-popover-item" :style="{width: `calc(100% / ${soldierExampleList.length})`}" v-for="(item, index) in soldierExampleList" :key="index">
                              <div class="item-name">{{ item.name }}</div>
                              <img class="item-image" :src="item.image" />
                            </div>
                          </div>
                        </a-tab-pane>
                        <a-tab-pane key="2" tab="伤残人民警察证" v-if="policeExampleList.length">
                          <div class="example-popover">
                            <div class="example-popover-item" :style="{width: `calc(100% / ${policeExampleList.length})`}" v-for="(item, index) in policeExampleList" :key="index">
                              <div class="item-name">{{ item.name }}</div>
                              <img class="item-image" :src="item.image" />
                            </div>
                          </div>
                        </a-tab-pane>
                      </a-tabs>
                    </div>
                  </template>
                  <span class="popover-text">证件样例</span>
                </a-popover>
              </h3>
              <div class="special-upload-tips" v-if="jjcCertUploadTips" v-html="jjcCertUploadTips"></div>
              <div class="upload-list">
                <div class="upload-item" v-for="(item, index) in jjcCertUploadList" :key="index">
                  <FileUpload @setFileList="getJjcFileList($event, item.type, 'jjcCertUploadList')" :showFormatTips="false" :fileTypeTitle="item.name" :fileLimit="1" :isJJC="true"></FileUpload>
                </div>
              </div>
              <h3>本人持证照片<span class="sub">照片须本人手持证件，证件号须清晰可见</span></h3>
              <div class="upload-list">
                <div class="upload-item" v-for="(item, index) in jjcSelfUploadList" :key="index">
                  <FileUpload @setFileList="getJjcFileList($event, item.type, 'jjcSelfUploadList')" :showFormatTips="false" :fileTypeTitle="item.name" :fileLimit="1" :isJJC="true"></FileUpload>
                </div>
              </div>
            </div>
            <!-- 优惠券是否展示的判断条件可能需要调整 -->
            <div class="mod mt-20 passenger-form-row" v-if="venusCouponEnable">
              <coupon
                v-if="isSelfAirline && !isSpecial && !ifInternational"
                ref="coupons"
                class="passenger-form-row"
                :coupons="coupons"
                :valid="couponValid"
                :loading="couponReady === 1"
                :selected="selectedCouponId"
                :couponAgreement="couponAgreement"
                @change="onCouponChange"
                @query="fetchCouponTicket"
              ></coupon>
            </div>
            <div class="mod mt-20 passenger-form-row" v-if="false">
              <div class="passenger-module" id="passenger-card-coupon">
                <card-module
                  ref="cards"
                  :cardCoupon="cardCoupon"
                  :valid="cardValid"
                  :loading="cardReady === 1"
                  :couponAgreement="couponAgreement"
                  @visible="fetchCardList"
                  @change="addCard"
                ></card-module>
              </div>
            </div>
            <div class="mod mt-20">
              <div id="passenger-contacts">
                <div class="passenger-module">
                  <Contacts @initContactData="initContactData" @inputItemValide="inputItemValide" :ifInternational="ifInternational"></Contacts>
                </div>
              </div>
            </div>
          </div>
          <div class="form-operation">
            <span class="passenger-btn-box">
              <a-button type="dashed" size="large" @click="reSearch">重选航班</a-button>
            </span>
            <span class="passenger-btn-box">
              <a-button type="primary" size="large" @click="handleNextStepValidate" :loading="loading">下 一 步</a-button>
            </span>
          </div>
        </a-form>
      </div>
    </div>
  </a-locale-provider>
</template>
<script>
import { updatePassengerNum, addPassengerInfo, queryUsualPassenger } from '@/apis/passenger'
import { addCoupon, removeCoupon, queryCoupon, queryCardCoupon, addCardCoupon } from '@/apis/coupon'
import { submitOrder } from '@/apis/order'
import { getCountry, fetchPopupContent, fetchDictionaryList } from '@/apis/common'
import { idTypeMap } from '@/dicts/order'
import { verifyOneself } from '@/apis/member'
import moment from 'moment'
import storage from '@/assets/js/storage'
import { getBirthDay, isYoungOrOld } from '@/assets/js/util'
import { validate } from '@/assets/js/validate'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import PassengerItem from './components/passengerItemV2.vue'
import PassengerItemInt from './components/passengerItemInt.vue'
import SpecialPassenger from './components/specialPassenger.vue'
import Contacts from './components/conatcts.vue'
import Coupon from './components/coupon-module'
import CardModule from './components/card-module'

import PassengerCountValidate from './components/validate.js'
import { userTypeMap } from '@/dicts/member'
import yoProductConfig from '@/data/yoProductConfig'
import 'moment/locale/zh-cn'
import _ from 'lodash'
import getAppInfo from '@/utils/from'
import flightSearchPopupMixin from '@/mixin/flightSearchPopup'
import { regPure } from '@/assets/js/validate/utils/name'
import FileUpload from '@/components/file-upload'
import './index'

moment.locale('zh-cn')
const mainSettings = window.__MICRO_ROOT__ ?? {}

let passengerIndex = 0
const sameNumberArr = [
  '00000000',
  '11111111',
  '22222222',
  '33333333',
  '44444444',
  '55555555',
  '66666666',
  '77777777',
  '88888888',
  '99999999'
]

const getNeedCountByPassengerType = (cart, type) => {
  return cart.passengerPrices?.find(item => { return item.passengerType === type })?.count || 0
}
const getCountByPassengerType = (usualPassengerList, checkPassengerItem, type) => {
  return usualPassengerList?.filter(item => {
    return checkPassengerItem.find(id => {
      return item.id === id && item.passengerType === type
    })
  })?.length || 0
}

export default {
  name: 'Passenger',
  mixins: [flightSearchPopupMixin],
  data () {
    return {
      cart: storage.getItem(`SHOPPINGCART_DATA`),
      user: null,
      isSpecial: Boolean(storage.getItem('isJJC')) || false,
      specialType: storage.getItem('isJJC'),
      form: this.$form.createForm(this, {
        name: 'passenger',
        onValuesChange: (_, values) => {
          this.onFormValuesChange(values)
        }
      }),
      usualPassengerCheckList: [], // 常用乘机人列表-用于渲染所有常用乘机人checkbok list
      usualPassenger: [], // 已勾选的常用乘机人
      usualPassengerList: [], // 用于记录乘机人是否被勾选
      forFormList: [], // 旅客表单,用于v-for遍历出表单dom
      loading: false,
      adultOriginList: [], // 表单中全部的成人
      adultList: [], // 表单中可选的成人
      adultSelectedList: [], // 表单中已选的成人
      coupons: [],
      couponReady: 0,
      selectedCoupons: [],
      selectedCouponId: '',
      couponValid: {},
      yoProduct: null,
      locale: zhCN,
      couponAgreement: [],
      passengerFieldInfo: [],
      ifInternational: false, // 国际票标识
      ifInviteRegisterFfp: false, // 邀请注册金鹏会员的产品标识
      isNorthAmericaSegment: false, // 北美航线标识
      oriDataList: [],
      dictionaryList: [],
      // cardCoupon: {},
      // cardValid: {},
      // cardReady: 0,
      venusCouponEnable: false, // NOTE: 下架 venus 优惠券
      shoppingCart: storage.getItem(`SHOPPINGCART_DATA`),
      payUrl: null,
      track: {
        startPostTime: null,
        endPostTime: null
      },
      passengerTypeInfo: [],
      jjcCertUploadList: [],
      jjcSelfUploadList: [],
      enableUploadJjcCert: false,
      jjcCertUploadTips: '',
      soldierExampleList: [],
      policeExampleList: [],
      activeKey: '1'
    }
  },
  computed: {
    isSelfAirline () {
      const { cart } = this
      if (!cart) {
        return
      }
      return _.get(cart, 'offers[0].detail.itinerarys[0].orgDsts[0].airlineCode') === mainSettings.airline
    },
    isDirectAccess () {
      const { cart } = this
      const isNotAllTransfer = Boolean(cart.offers.find(offer => {
        return offer.detail.itinerarys.find(itinerary => {
          return itinerary.itineraryType !== 'CT'
        })
      }))
      let flag = false
      if (!isNotAllTransfer) {
        flag = true
      }
      return flag
    },
    departureDate () {
      const { cart } = this
      if (!cart) {
        return
      }
      if (cart && cart.offers) {
        const offers = cart.offers
        const offerLen = offers.length
        return offers[offerLen - 1].detail.itinerarys[0].orgDsts[0].departureDate
      } else {
        return null
      }
    },
    arrivalDate () {
      const { cart } = this
      if (!cart) {
        return
      }
      if (cart && cart.offers && cart.offers.length > 1) {
        const offers = cart.offers

        return offers[1].detail.itinerarys[0].orgDsts[0].departureDate
      } else {
        return null
      }
    },
    adultDate () {
      const { departureDate } = this
      if (departureDate) {
        return moment(departureDate).subtract(18, 'y')
      }

      return null
    },
    schoolChildrenDateRange () {
      const { departureDate } = this
      if (departureDate) {
        return [moment(departureDate).subtract(5, 'y'), moment(departureDate).subtract(3, 'y')]
      }

      return []
    }
  },
  watch: {
    forFormList (value) {
      const { ifInternational, venusCouponEnable } = this
      this.couponReady = 0
      if ((!value.length || value.length > 1) && this.$refs.coupons) {
        this.$refs.coupons.show = false
      }

      if (!ifInternational && venusCouponEnable) {
        this.couponValid = this.getCouponValid()
      }
    }
  },
  created () {
    const { cart } = this
    if (cart) {
      this.ifInternational = cart.ifInternational
      this.ifInviteRegisterFfp = cart.ifInviteRegisterFfp
      this.isNorthAmericaSegment = cart.isNorthAmericaSegment
      const user = mainSettings.user?.get()
      if (user) {
        this.user = {
          chiName: user.fullName,
          mobile: user.phone,
          email: user.email,
          userType: userTypeMap[user.userType],
          name: user.loginName,
          hasAuth: user.userType !== 0 || user.authStatus === 4
        }
      }

      const isAgent = [1, 2].includes(window.__MICRO_ROOT__?.user?.get()?.userType)
      this.payUrl = !isAgent ? '/pay/v2/pay' : '/pay/v1/pay'
      this.getCountryByApi()
      this.initPassengerFormListData()
      this.verifyProductInit()
      this.getUsualPassenger()
      this.getCmsData()
      const searchParams = {}
      if (this.ifInternational) {
        searchParams.flightType = 'InternationalFlights'
        this.fetchDictionaryListByApi()
      } else {
        searchParams.flightType = 'DomesticFlights'
      }
      this.getAllPopup(searchParams)
      // this.queryCardCoupon()
    } else {
      this.$error({
        title: '温馨提示',
        content: '预订异常，请重新下单',
        onOk: () => {
          this.$router.push({ path: '/flight/search' })
        }
      })
    }
    window.__MICRO_ROOT__?.api?.track?.('reserve_passenger_view')
    window.__MICRO_ROOT__?.api?.track?.('reserve_passenger_loadingime')
  },
  mounted () {
    // 将 forFormList 赋值给 form
    const { isSpecial, ifInviteRegisterFfp, user } = this
    if (!isSpecial) {
      this.forFormList.forEach((psg, index) => {
        this.form.setFieldsValue({
          [`passengers[${index}].passengerType`]: psg.passengerType,
          [`passengers[${index}].isUsual`]: true,
          [`passengers[${index}].idType`]: psg.idType
        })
      })
    } else {
      // NOTE: ALL - 实名认证后默认赋值
      this.forFormList.forEach((psg, index) => {
        this.form.setFieldsValue({
          [`passengers[${index}].fullName`]: user.chiName
        })
      })
    }
    if (ifInviteRegisterFfp) {
      this.forFormList.forEach((psg, index) => {
        this.form.setFieldsValue({
          [`passengers[${index}].isInvite`]: true
        })
      })
    }
    // 国际票暂不支持优惠券
    // if (!cart.ifInternational) {
    //   this.validCoupon()
    // }
  },
  methods: {
    getJjcFileList (files, type, listName) {
      if (_.every(files, { status: 'done' })) {
        this[listName] = this[listName].map(p => {
          if (p.type === type) {
            const fileList = files.map(file => {
              return {
                url: file.response?.url,
                scene: 'JJC_CERT',
                photoType: type
              }
            })
            return {
              ...p,
              files: fileList
            }
          } else {
            return p
          }
        })
      }
    },
    getAllPopup (searchParams, type = 'Passenger', channel = 'pc') {
      const params = { type, channel, ...searchParams }
      fetchPopupContent(params)
        .then(data => {
          this.doSearchCond(data)
        })
        .catch(err => {
          this.$message.error(err.message || '网络异常，请稍后再试！')
        })
    },
    initPassengerFormListData () {
      const { cart } = this
      this.forFormList.length = 0
      // 初始化得到订单人数schema
      const passengerInfo = (!cart.ifInternational ? _.get(cart, 'offers[0].detail.ticketCartItems[0].detail.passengerPrices') : cart.passengerPrices) || []
      // 确保表单先渲染成人
      const adultIndex = _.findIndex(passengerInfo, res => {
        return res.passengerType === 'ADT'
      })
      const adult = passengerInfo[adultIndex]
      const adultCount = parseInt(adult.count)
      for (let i = 0; i < adultCount; i++) {
        const formItem = {
          passengerType: 'ADT',
          isUsual: true,
          key: passengerIndex++,
          idType: 'NI',
          nationality: 'CN',
          issueCountry: 'CN'
        }
        if (cart.ifInternational) {
          formItem.areaCode = '86'
          formItem.idType = 'PP'
        }
        this.forFormList.push(formItem)
      }
      // 再渲染成人外的旅客
      passengerInfo.forEach((psg, index) => {
        const count = parseInt(psg.count)
        if (index !== adultIndex) {
          for (let i = 0; i < count; i++) {
            const passengerItem = {
              passengerType: psg.passengerType,
              isUsual: true,
              key: passengerIndex++
            }
            if (cart.ifInternational) {
              passengerItem.areaCode = '86'
              passengerItem.idType = 'PP'
            }
            this.forFormList.push(passengerItem)
          }
        }
      })
    },
    async getCmsData () {
      try {
        const cmsData = (await mainSettings.cms?.getPageData()) || {}
        this.couponAgreement = _.get(cmsData, 'coupon-agreement.list') || []
        this.passengerFieldInfo = _.get(cmsData, 'passenger-field-info.list') || []
        this.passengerTypeInfo = _.get(cmsData, 'passenger-type-info.list') || []
        this.jjcCertUploadList = _.get(cmsData, 'jjc-cert-upload-config.jjcCertUploadList') || []
        this.jjcSelfUploadList = _.get(cmsData, 'jjc-cert-upload-config.jjcSelfUploadList') || []
        this.enableUploadJjcCert = _.get(cmsData, 'jjc-cert-upload-config.enableUploadJjcCert') || false
        this.jjcCertUploadTips = _.get(cmsData, 'jjc-cert-upload-config.jjcCertUploadTips') || ''
        this.soldierExampleList = _.get(cmsData, 'jjc-cert-upload-config.soldier') || []
        this.policeExampleList = _.get(cmsData, 'jjc-cert-upload-config.police') || []
        this.activeKey = this.soldierExampleList.length ? '1' : '2'
      } catch (err) {}
    },
    isDisabledChangeBirthday (index) {
      const passengerValue = this.form.getFieldsValue()
      if (passengerValue && passengerValue.passengers && Array.isArray(passengerValue.passengers)) {
        const passenger = passengerValue.passengers[index]
        if (passenger) {
          return !!['NI'].includes(passenger.idType)
        }
      }
    },
    // 对特殊的产品进行单独校验 - 初始化时
    verifyProductInit () {
      const { cart } = this
      const yoProduct = _.find(yoProductConfig, { airline: mainSettings.airline })
      if (yoProduct) {
        // 校验青老年产品的对乘机人证件和年龄的判断
        const isQLNTH = Boolean(cart.offers.find(offer => {
          return offer.detail.itinerarys.find(itinerary => {
            return itinerary.orgDsts.find(orgDst => {
              return orgDst.productCode === yoProduct.productCode
            })
          })
        }))
        if (isQLNTH) this.yoProduct = yoProduct
      }
    },
    // 对特殊的产品进行单独校验 - 表单变化时
    verifyProductOnFormChange (fullField, value, callback, fuildName) {
      if (this.ifInternational) {
        callback && callback()
      }
      if (this.yoProduct) {
        const { yoProduct, form, departureDate } = this
        const { youngMin, youngMax, oldMin } = yoProduct
        const idx = this.getFieldIndex(fullField)
        const isAdult = form.getFieldsValue().passengers[idx] ? form.getFieldsValue().passengers[idx].passengerType === 'ADT' : false
        if (isAdult) {
          if (fuildName === 'idType' && value.idType !== 'NI') {
            const errorContent = '预订青老年特惠产品，须使用身份证。'
            callback(errorContent)
          }
          if (fuildName === 'certificateNo' && !isYoungOrOld(value.certificateNo, departureDate, { youngMin, youngMax, oldMin })) {
            const errorContent = `预订青老年特惠产品，须为${youngMin}-${youngMax}周岁及${oldMin}周岁以上。`
            callback(errorContent)
          }
        }
      }
    },
    /**
     * 获取常用乘机人列表
     */
    getUsualPassenger () {
      queryUsualPassenger({}).then(result => {
        if (result.length > 0) {
          this.usualPassengerCheckList = result.map(item => {
            // 兼容 oj 导入的常用乘机人数据，passengerName 存在'张/三'格式
            if (!regPure.test(item.passengerName)) {
              const idTypes = item.passengerCards.map(item => item.idType)
              const hasDomestic = _.intersection(['NI', 'HM', 'ID26'], idTypes)?.length > 0
              if (!hasDomestic && item.lastName && item.firstName) {
                item.passengerName = item.lastName + '/' + item.firstName
              } else if (hasDomestic && item.surnameCn && item.nameCn) {
                item.passengerName = item.surnameCn + item.nameCn
              }
            }
            const passengerItem = {
              value: item.id,
              label: item.passengerName,
              passengerType: item.passengerType
            }

            return passengerItem
          })
          this.usualPassengerList = result
        } else {
          this.usualPassengerList = []
          this.usualPassengerCheckList = []
        }
      }).catch(e => {
        this.usualPassengerList = []
        this.usualPassengerCheckList = []
        this.$message.error(e.message)
      })
    },

    /**
     * 勾选/去勾选 常用乘机人 回调函数
     */
    selectUsual (values) {
      const { ifInternational, usualPassenger, cart, isSelfAirline } = this
      const formList = this.form.getFieldValue('passengers')

      if (!values.length && formList.length === 1) {
        this.clearFormPassenger()
        this.usualPassenger = []
        return
      }

      // 国际票处理
      if (ifInternational) {
        const { usualPassengerList } = this
        const adultNeedLen = getNeedCountByPassengerType(cart, 'ADT')
        const childNeedLen = getNeedCountByPassengerType(cart, 'CHD')
        const infantNeedLen = getNeedCountByPassengerType(cart, 'INF')
        const adultLen = getCountByPassengerType(usualPassengerList, values, 'ADT')
        const childLen = getCountByPassengerType(usualPassengerList, values, 'CHD')
        const infantLen = getCountByPassengerType(usualPassengerList, values, 'INF')
        const passengerNum = cart.passengerPrices.map(item => item.count).reduce((sum, num) => +sum + Number(num))
        if ((values.length > passengerNum || adultLen > adultNeedLen || childLen > childNeedLen || infantLen > infantNeedLen)) {
          this.$message.error(`你选择的是${adultLen}成人/${childLen}儿童/${infantLen}婴儿，与查询时的${adultNeedLen}成人/${childNeedLen}儿童/${infantNeedLen}婴儿不一致可能导致价格变动，如需调整请重新选择乘机人`)
          return false
        }
      }

      const isAdd = values.length > usualPassenger.length
      const id = isAdd ? _.difference(values, usualPassenger)[0] : _.difference(usualPassenger, values)[0]
      let result = false
      if (isAdd) {
        const item = _.find(this.usualPassengerList, item => item.id === id)
        if (['JD', 'Y8'].includes(mainSettings.airline)) {
          const hasChild = formList.findIndex(item => { return item.passengerType === 'CHD' }) >= 0
          const hasAudlt = formList.findIndex(item => { return item.passengerType === 'ADT' && item.certificateNo }) >= 0
          if (isSelfAirline && item.passengerType === 'CHD' && !hasChild && hasAudlt) {
            this.$message.warn(`每名年满18周岁且具有完全民事行为能力的成人最多可带3名未满5岁的儿童（含1名婴儿）；携带5（含）至12岁（不含）以下儿童无数量限制。如同行的儿童为残疾儿童，则仅可携带一名残疾儿童出行，不能再携带其他儿童及婴儿旅客同行，详情可联系${getAppInfo()?.hotline}咨询。`)
          }
        }
        result = !ifInternational ? this.insertUsualPassenger(item) : this.insertUsualPassengerInt(item)
      } else {
        const idx = _.findIndex(formList, item => item.id === id)
        if (idx >= 0) {
          result = !ifInternational ? this.removePassenger(idx) : this.clearFormPassenger(idx)
        }
      }

      if (result) {
        this.usualPassenger = values
      }
    },
    insertUsualPassengerInt (passenger) {
      let insert = false
      const { forFormList } = this
      const formList = this.form.getFieldValue('passengers')
      // 处理生日
      const birthday = passenger.birthday
      passenger.passengerType = passenger.passengerType || 'ADT'
      passenger.birthdayObj = moment(birthday, 'YYYY-MM-DD')
      passenger.isUsual = true
      passenger.fullName = passenger.passengerName

      const defaultPassengerCard = passenger.passengerCards?.find(item => { return item.idType === 'PP' }) ?? {}
      passenger = {
        ...passenger,
        certExpried: defaultPassengerCard.certExpried,
        certificateNo: defaultPassengerCard.certificateNo,
        issueCountry: defaultPassengerCard.issueCountry,
        idType: defaultPassengerCard.idType
      }
      passenger.certExpriedObj = passenger.certExpried ? moment(passenger.certExpried, 'YYYY-MM-DD') : ''

      for (let i = 0, len = formList.length; i < len; i++) {
        const psg = formList[i]
        if ((!insert && !psg.fullName && !psg.certificateNo && forFormList[i].passengerType === passenger.passengerType)) {
          // 当勾选的常用乘机人，与已渲染出来的空白表单旅客类型吻合时，并且该表单空白时，将乘机人信息填入其中
          insert = true
          this.setPassengerField(i, passenger)
          return true
        }
      }
      if (!insert) {
        this.$message.error(`旅客类型不符，请重新选择`)
      }
    },
    insertUsualPassenger (passenger) {
      let insert = false
      const { forFormList } = this
      const formList = this.form.getFieldValue('passengers')
      // 处理生日
      const birthday = passenger.birthday
      passenger.passengerType = passenger.passengerType || 'ADT'
      passenger.birthdayObj = moment(birthday, 'YYYY-MM-DD')
      passenger.isUsual = true
      passenger.fullName = passenger.passengerName
      const defaultPassengerCard = passenger.passengerCards?.[0] ?? {}
      passenger = {
        ...passenger,
        certExpried: defaultPassengerCard.certExpried,
        certificateNo: defaultPassengerCard.certificateNo,
        issueCountry: defaultPassengerCard.issueCountry,
        idType: defaultPassengerCard.idType
      }
      passenger.certExpriedObj = passenger.certExpried ? moment(passenger.certExpried, 'YYYY-MM-DD') : ''
      for (let i = 0, len = formList.length; i < len; i++) {
        const psg = formList[i]
        if (!insert && !psg.fullName && !psg.certificateNo && forFormList[i].passengerType === passenger.passengerType) {
        // 当勾选的常用乘机人，与已渲染出来的空白表单旅客类型吻合时，并且该表单空白时，将乘机人信息填入其中
          insert = true
          this.setPassengerField(i, passenger)
          this.updatePassengerNum()
          return true
        }
      }

      if (this.selectedCoupons.length) {
        const h = this.$createElement
        this.$error({
          title: '温馨提示',
          content: h('div', {}, [
            h('p', '1. 您选择已使用优惠券，优惠券仅支持单人使用，如需继续添加乘机人，请先取消优惠券。'),
            h('p', '2. 该优惠券适用于年满12周岁以上乘客购票使用。')
          ])
        })
        return false
      }

      // 当勾选的常用乘机人，与已显然出来的空白表单旅客类型不吻合时，新增一栏乘机人表单
      if (!insert) {
        const valid = PassengerCountValidate(this.form.getFieldValue('passengers'), 'add', passenger, this)
        if (valid.value) {
          forFormList.push({
            passengerType: passenger.passengerType,
            idType: passenger.certificateType,
            isUsual: true,
            key: passengerIndex++
          })
          const index = forFormList.length - 1
          // forFormList增加之后，passenger的渲染存在一个延时，所以这里设置一个setTimeout
          this.$nextTick(() => {
            this.setPassengerField(index, passenger)
            this.updatePassengerNum()
          })
          if (valid.warn) {
            this.$message.warn(valid.message)
          }
          return true
        } else {
          this.$message.error(valid.message)
          return false
        }
      }
    },
    // 数据填入表单
    setPassengerField (index, passenger) {
      let data = {}
      const { ifInternational } = this
      if (!ifInternational) {
        data = {
          id: passenger.id,
          passengerType: passenger.passengerType,
          isUsual: passenger.isUsual,
          fullName: passenger.fullName,
          idType: passenger.idType || passenger.certificateType,
          certificateNo: passenger.certificateNo,
          birthday: passenger.birthday,
          birthdayObj: passenger.birthdayObj,
          areaCode: passenger.areaCode || '86',
          mobile: passenger.telephoneNo
        }
        if (!['NI', 'HM', 'ID26'].includes(data.idType)) {
          data = {
            ...data,
            passengerFirstName: passenger.nameCn || passenger.firstName || passenger.passengerFirstName,
            passengerLastName: passenger.surnameCn || passenger.lastName || passenger.passengerLastName,
            gender: passenger.gender || undefined,
            nationality: passenger.nationality,
            certExpried: passenger.certExpried,
            certExpriedObj: passenger.certExpriedObj,
            issueCountry: passenger.issueCountry
          }
        }
      } else {
        const { street, city, zipCode, countryCode, provinceCode, id: destId } = passenger?.passengerAddressList?.[0] ?? ''
        data = {
          id: passenger.id,
          passengerType: passenger.passengerType,
          isUsual: passenger.isUsual,
          fullName: passenger.fullName,
          passengerFirstName: passenger.firstName || passenger.passengerFirstName,
          passengerLastName: passenger.lastName || passenger.passengerLastName,
          idType: 'PP',
          certificateNo: passenger.idType === 'PP' ? passenger.certificateNo : '',
          areaCode: passenger.areaCode || '86',
          mobile: passenger.telephoneNo,
          birthday: passenger.birthday,
          birthdayObj: passenger.birthdayObj,
          gender: passenger.gender || undefined,
          nationality: passenger.nationality,
          certExpried: passenger.certExpried,
          certExpriedObj: passenger.certExpriedObj,
          issueCountry: passenger.issueCountry,
          street,
          city,
          zipCode,
          countryAndStateCodeMix: [countryCode, provinceCode],
          destId
        }
      }

      this.$nextTick(() => {
        this.$set(this.forFormList[index], 'idType', data.idType)
        this.form.setFieldsValue({
          [`passengers[${index}]`]: data
        })
      })
    },
    /**
     * 根据索引删除一行旅客
     * @param index 待删除的列表索引
     * @param isEmit 是否是由passengerItem组件的close方法emit调用
     */
    removePassenger (index, isEmit) {
      const list = this.form.getFieldValue('passengers')
      const passengerType = list[index].passengerType
      const valid = PassengerCountValidate(list, 'reduce', list[index], this)

      if (valid.value) {
        const passenger = list.splice(index, 1)[0]
        this.forFormList.splice(index, 1)

        if (isEmit && passenger.id) {
          const idx = this.usualPassenger.indexOf(passenger.id)

          if (idx > -1) {
            this.usualPassenger.splice(idx, 1)
          }
        }

        // 如果是成人，并且婴儿携带者为该成人，要去掉携带者字段值
        if (passengerType === 'ADT') {
          const idx = _.findIndex(list, item => {
            return item.passengerType === 'INF' && item.adultName === passenger.fullName
          })

          if (idx > -1) {
            list[idx].adultName = ''
          }
        }

        this.$nextTick(() => {
          this.form.setFieldsValue({
            passengers: list
          })
          this.updatePassengerNum()
        })
        if (valid.warn) {
          this.$message.warn(valid.message)
        }
        return true
      } else {
        this.$message.error(valid.message)
        return false
      }
    },
    /**
     * 清空表单数据
     */
    clearFormPassenger (index = 0) {
      const passengers = []
      passengers[index] = {
        'id': null,
        'isUsual': true,
        'idType': undefined,
        'fullName': '',
        'certificateNo': '',
        'areaCode': '86',
        'mobile': '',
        'birthday': '',
        'birthdayObj': '',
        'passengerFirstName': '',
        'passengerLastName': '',
        'surnameCn': '',
        'nameCn': '',
        'gender': undefined,
        'nationality': undefined,
        'certExpried': '',
        'certExpriedObj': '',
        'issueCountry': undefined,
        'destId': '',
        'countryAndStateCodeMix': [],
        'city': '',
        'street': '',
        'zipCode': ''
      }
      // if (!['NI', 'HM'].includes(passengers[index].idType)) {
      //   passengers[index] = {
      //     ...passengers[index]
      //   }
      // }
      passengers[index].idType = this.ifInternational ? 'PP' : 'NI'
      if (this.ifInternational) {
        if (passengers[index].passengerType === 'INF') {
          passengers[index].adultName = undefined
          passengers[index].idType = ''
          passengers[index].areaCode = ''
        }
        const list = this.form.getFieldValue('passengers')
        const passenger = list.splice(index, 1)[0]
        if (passenger.id) {
          const idx = this.usualPassenger.indexOf(passenger.id)

          if (idx > -1) {
            this.usualPassenger.splice(idx, 1)
          }
        }
      }
      this.$nextTick(() => {
        this.$set(this.forFormList[index], 'idType', passengers[index].idType)
        this.form.setFieldsValue({ [`passengers[${index}]`]: passengers[index] })
      })
    },
    /**
     * 组合输入项的数据以供验证
     */
    inputItemValide (fullField, value, callback) {
      let data = {}
      if (fullField.indexOf('fullName') > -1) {
        data = {
          fullName: value
        }
        if (fullField.indexOf('passengers') > -1) {
          const typeField = fullField.replace('fullName', 'passengerType')
          const passengerType = this.form.getFieldValue(typeField)
          data.passengerType = passengerType || ''
        }
      } else if (fullField.indexOf('adultName') > -1) {
        data = {
          adultName: value
        }
      } else if (fullField.indexOf('idType') > -1) {
        // 验证证件类型
        data = {
          idType: value
        }
      } else if (fullField.indexOf('certificateNo') > -1) {
        // 验证证件号码
        const typeField = fullField.replace('certificateNo', 'idType')
        const idType = this.form.getFieldValue(typeField)
        data = {
          certificateNo: value,
          idType: idType
        }
      } else if (fullField.indexOf('specialCertificateNo') > -1) {
        data = {
          specialCertificateNo: value
        }
      } else if (fullField.indexOf('mobile') > -1) {
        // 验证电话号码
        const typeField = fullField.replace('mobile', 'areaCode')
        const countryCode = this.form.getFieldValue(typeField)
        data = {
          mobile: value
        }
        if (countryCode) {
          data.countryCode = countryCode
        }
      } else if (fullField.indexOf('birthdayObj') > -1) {
        // 验证出生日期
        let birthday = ''
        const typeField = fullField.replace('birthdayObj', 'passengerType')
        let passengerType = this.form.getFieldValue(typeField)
        if (passengerType === 'CHD') {
          passengerType = 'CNN'
        }
        if (value) {
          birthday = value.format('YYYY-MM-DD')
        }

        data = {
          birthday: birthday,
          passengerType: passengerType,
          departureDate: this.departureDate
        }

        if (this.arrivalDate) {
          data.departureDate2 = this.arrivalDate
        }
      } else if (fullField.indexOf('contactMobile') > -1) {
        // 验证电话号码
        const countryCode = this.form.getFieldValue('customer.countryCode')
        data = {
          contactMobile: value,
          countryCode: countryCode
        }
      } else if (fullField.indexOf('email') > -1) {
        data = {
          email: value
        }
      } else if (fullField.indexOf('certExpriedObj') > -1) {
        // 验证证件有效期
        let certExpried = ''
        if (value) {
          certExpried = value.format('YYYY-MM-DD')
        }
        data = {
          certExpried: certExpried
        }
      } else {
        // 补充国际票字段
        const len = fullField.split('.').length
        const key = fullField.split('.')[len - 1]
        const fieldIndex = this.getFieldIndex(fullField)

        data[key] = value
        if (key === 'passengerLastName') {
          data['passengerType'] = this.form.getFieldsValue().passengers[fieldIndex]?.passengerType
          data['passengerFirstName'] = this.form.getFieldsValue().passengers[fieldIndex]?.passengerFirstName
        }

        if (key === 'passengerFirstName') {
          data['passengerType'] = this.form.getFieldsValue().passengers[fieldIndex]?.passengerType
          data['passengerLastName'] = this.form.getFieldsValue().passengers[fieldIndex]?.passengerLastName
        }
      }
      this.handleFieldValidate(fullField, data, callback)
    },
    /**
     * 验证表单输入内容
     */
    handleFieldValidate (fullField, value, callback) {
      const { ifInternational } = this
      let fuildName = fullField.indexOf('.') > -1 ? fullField.split('.')[1] : fullField

      if (fuildName === 'birthdayObj') {
        fuildName = 'birthday'
      }

      if (fuildName === 'certExpriedObj') {
        fuildName = 'certExpried'
      }
      const fieldIndex = this.getFieldIndex(fullField)
      const idType = this.form.getFieldsValue().passengers[fieldIndex]?.idType
      let validateName = 'passenger'
      if (!['NI', 'HM', 'ID26'].includes(idType) && !ifInternational) {
        validateName = 'passengerv2'
      } else if (ifInternational) {
        validateName = 'passengerInt'
      }

      validate(validateName, value, fuildName).then(({ valid, errors }) => {
        if (valid) {
          if (!this.loading) {
            // 修改表单时触发
            // 自动填充生日
            if (fuildName === 'certificateNo' && (['NI'].includes(value.idType))) {
              const index1 = this.getFieldIndex(fullField)
              this.fillBirthday(value.certificateNo, index1)
            }
            if (fuildName === 'certExpried') {
              const index2 = this.getFieldIndex(fullField)
              this.form.setFieldsValue({ [`passengers[${index2}].certExpried`]: value.certExpried })
            }
            if (fuildName === 'birthday') {
              const index2 = this.getFieldIndex(fullField)
              this.form.setFieldsValue({ [`passengers[${index2}].birthday`]: value.birthday })
            }
            this.verifyProductOnFormChange(fullField, value, callback, fuildName)
          } else {
            // 提交时触发
            this.verifyProductOnFormChange(fullField, value, callback, fuildName)
          }
          callback && callback()
        } else {
          let errorMessage = errors[0].message
          if (mainSettings.airline === 'FU' && errors[0]?.path === 'contactMobile') {
            errorMessage = '请您填写乘机人及联系人真实有效的联系方式，以便接收航空公司推送的重要服务信息，以及在紧急特殊情况下的联系。'
          }
          callback(errorMessage)
        }
      })
    },
    notUploadJjcErrorTip (list) {
      for (let i = 0; i < list.length; i++) {
        const item = list[i]
        if (!item.files?.length) {
          this.loading = false
          this.$error({
            title: '温馨提示',
            content: item.errMsg || '请上传军警残相关证件'
          })
          return false
        }
      }
      return true
    },
    /**
     * 提交表单，完成添加乘机人到购物车
     */
    handleNextStepValidate () {
      this.loading = true
      this.form.validateFields(async (err, values) => {
        if (!err) {
          const { form, isSpecial, cart, user, ifInternational } = this
          let formValues = _.cloneDeep(form.getFieldsValue())
          let mobileArr = []

          formValues.customer.mobile = formValues.customer.contactMobile
          formValues.customer.areaCode = formValues.customer.countryCode
          formValues.shoppingCartId = cart.shoppingCartId
          delete formValues.customer.contactMobile
          delete formValues.customer.countryCode

          // 通用校验
          // 判断是否有重复的电话
          let repeat = false
          const len = mobileArr.length
          for (let m = 0; m < len - 1; m++) {
            for (let o = m + 1; o < len; o++) {
              if (mobileArr[m] === mobileArr[o]) {
                repeat = true
                break
              }
            }
          }
          if (repeat) {
            this.loading = false
            this.$error({
              title: '温馨提示',
              content: '乘机人的手机号码不可重复'
            })
            return false
          }

          // 国内、国际校验
          if (!ifInternational) {
            // 用于判断乘客中是否有儿童
            let hasChild = false
            let hasInfant = false
            // 用于判断证件类型选择身份证和户口簿时，证件号码和出生日期是否一致
            let validateFlag = true

            if (isSpecial) {
              if (this.enableUploadJjcCert) {
                if (!this.notUploadJjcErrorTip(this.jjcCertUploadList)) return
                if (!this.notUploadJjcErrorTip(this.jjcSelfUploadList)) return

                let uploadFiles = []
                this.jjcCertUploadList.forEach(item => {
                  uploadFiles = uploadFiles.concat(item.files)
                })
                this.jjcSelfUploadList.forEach(item => {
                  uploadFiles = uploadFiles.concat(item.files)
                })
                formValues.uploadFiles = uploadFiles
              }
              // TODO: 8L个性化处理，讨论是否保留
              if (formValues.passengers[0].fullName !== user.chiName && mainSettings.airline === '8L') {
                this.$error({
                  title: '温馨提示',
                  content: '军警残客票仅支持实名认证本人购票，请确认旅客姓名是否填写正确。'
                })
                this.loading = false
                return
              }
              formValues.passengers[0].passengerType = 'ADT'
              formValues.passengers[0].specialCertificateType = this.specialType
              formValues.passengers[0].certificateType = formValues.passengers[0].idType
              formValues.passengers[0].icommPassenger = false
              delete formValues.passengers[0].idType
            } else {
              formValues.passengers.forEach((psg, index) => {
                formValues.passengers[index].certificateType = psg.idType
                formValues.passengers[index].icommPassenger = psg.isUsual
                formValues.passengers[index].firstName = psg.passengerFirstName
                formValues.passengers[index].lastName = psg.passengerLastName
                if (psg.isInvite && psg.passengerType !== 'INF') {
                  formValues.passengers[index].ifAcceptInviteRegisterFfp = psg.isInvite
                }
                if (psg.passengerType === 'INF') {
                  hasInfant = true
                  let name = this.getPassengerInfoByName(psg.adultName)
                  if (!name) {
                    return
                  }
                  formValues.passengers[index].accompanyPassenger = name
                } else if (psg.passengerType === 'CHD') {
                  hasChild = true
                } else {
                  if (psg.passengerType === 'ADT') {
                    mobileArr.push(psg.mobile)
                  }
                }
                if (formValues.passengers[index].birthday && ['NI'].includes(formValues.passengers[index].certificateType)) {
                  if (getBirthDay(formValues.passengers[index].certificateNo).birthday !== formValues.passengers[index].birthday) {
                    this.$message.error(`出生日期与${idTypeMap[formValues.passengers[index].certificateType]}不一致，请到常用乘机人信息去修改`)
                    validateFlag = false
                  }
                }
                if (['NI'].includes(formValues.passengers[index].certificateType)) {
                  formValues.passengers[index].nationality = 'CN'
                }

                delete formValues.passengers[index].idType
                delete formValues.passengers[index].isUsual
                delete formValues.passengers[index].isInvite
                delete formValues.passengers[index].passengerFirstName
                delete formValues.passengers[index].passengerLastName
              })
            }

            // JD - 个性化校验
            if (['JD', 'Y8'].includes(mainSettings.airline)) {
              const { isSelfAirline } = this
              const { passengers } = formValues
              const { guardianCount, cnnCount, infCount, preschoolCnnCount } = this.getPassengerCount(passengers)
              if (isSelfAirline) {
                if (preschoolCnnCount > 0) {
                  if ((preschoolCnnCount + infCount) > guardianCount * 3) {
                    this.$message.error(`每名年满18周岁且具有完全民事行为能力的成人最多可带1名不满5岁的残疾儿童或3名不满5岁儿童或2名不满5岁儿童及1名婴儿或1名不满5岁儿童及2名婴儿（其中一名婴儿按普通婴儿购票，另一名婴儿需提供经局方批准的儿童限制装置后可按占座儿童购票，详情可联系${getAppInfo()?.hotline}咨询）。您输入的旅客信息不符合要求，请修改旅客信息后重新预订。`)
                    validateFlag = false
                  }
                } else {
                  if (infCount > guardianCount) {
                    this.$message.error(`每名年满18周岁且具有完全民事行为能力的成人可携带一名婴儿同行，如有第二名婴儿同行，在婴儿旅客父母、监护人或者指定的护理人员提供经局方批准的儿童限制装置时，可按照占座儿童购票，详情请联系客服${getAppInfo()?.hotline}处理。您输入的旅客信息不符合要求，请修改旅客信息后重新预订。`)
                    validateFlag = false
                  }
                }
              } else {
                if (guardianCount * 2 < cnnCount || guardianCount < infCount) {
                  this.$message.error(`预订非${getAppInfo()?.name}实际承运的国内航班，每名年满18周岁的成人最多可携带2名儿童及1名婴儿。您输入的旅客信息不符合要求，请修改信息后重新预订。`)
                  validateFlag = false
                }
              }
            }

            // TODO: 后续配置成 cms 规则
            if (mainSettings.airline === 'UQ') {
              const validateByUQ = Boolean(cart.offers.find(offer => {
                return offer.detail.itinerarys.find(itinerary => {
                  return itinerary.orgDsts.find(orgDst => {
                    return (['GQA1', 'GQB1'].includes(orgDst.productCode) && (hasChild || hasInfant))
                  })
                })
              }))
              if (validateByUQ) {
                this.$message.error(`该产品仅支持成人购买。`)
                validateFlag = false
              }
            }
            if (!validateFlag) {
              this.loading = false
              return false
            }

            // 判断是否存在连续8位相同数字，提示不能购买保险
            let sameMobile = ''
            for (let i = 0; i < len; i++) {
              sameNumberArr.forEach(item => {
                if (mobileArr[i].indexOf(item) > -1) {
                  sameMobile = mobileArr[i]
                }
              })

              if (sameMobile) {
                break
              }
            }
            if (sameMobile) {
              this.$confirm({
                title: '温馨提示',
                content: `旅客您好，手机号码${sameMobile}存在8位连续相同数字，线上购买保险将无法正常出单，请确认手机号码是否填写正确`,
                okText: '确定',
                cancelText: '取消',
                onOk: () => {
                  this.handleNextStepSubmit(formValues)
                },
                onCancel: () => {
                  this.loading = false
                }
              })
              return false
            }

            // 如果有儿童，判断是否有W舱
            if (hasChild) {
            // TODO: 8L专属提示，待配置化
              if (mainSettings.airline === '8L') {
                let isCabinW = false

                for (let i = 0, len = cart.offers.length; i < len; i++) {
                  const offer = cart.offers[i]

                  if (offer.type === 'Flight') {
                    if (offer.detail.itinerarys[0].orgDsts[0].cabinCode.toLocaleUpperCase() === 'W') {
                      isCabinW = true
                      break
                    }
                  }
                }

                if (isCabinW) {
                  this.$confirm({
                    title: '温馨提示',
                    content: 'W舱产品运价超过五折时，儿童仍可购买经济舱五折票价，退改签费率与Y舱一致。',
                    okText: '确定',
                    cancelText: '取消',
                    onOk: () => {
                      this.handleNextStepSubmit(formValues)
                    },
                    onCancel: () => {
                      this.loading = false
                    }
                  })
                  return false
                }
              }
            }
          } else {
            formValues.passengers.forEach((psg, index) => {
              formValues.passengers[index].certificateType = psg.idType
              formValues.passengers[index].icommPassenger = psg.isUsual
              formValues.passengers[index].firstName = psg.passengerFirstName
              formValues.passengers[index].lastName = psg.passengerLastName

              formValues.passengers[index].destCountryCode = psg.countryAndStateCodeMix?.[0]
              formValues.passengers[index].destStateCode = psg.countryAndStateCodeMix?.[1]
              formValues.passengers[index].destCity = psg.city
              formValues.passengers[index].destAddress = psg.street
              formValues.passengers[index].destZipCode = psg.zipCode
              if (psg.destId) {
                formValues.passengers[index].destId = psg.destId
              }
              if (psg.passengerType === 'INF') {
                let name = this.getPassengerInfoByName(psg.adultName)
                if (!name) {
                  return
                }
                formValues.passengers[index].accompanyPassenger = name
              }
              delete formValues.passengers[index].idType
              delete formValues.passengers[index].isUsual
              delete formValues.passengers[index].passengerFirstName
              delete formValues.passengers[index].passengerLastName
            })
          }

          this.handleNextStepSubmit(formValues)
        } else {
          this.loading = false
          this.$message.error('请补充完整表单信息！')
          console.log('err >>>> ', err)
        }
      })
    },
    handleNextStepSubmit (formValues) {
      const { ifInternational } = this
      if (ifInternational) {
        formValues.ifInternational = ifInternational
      }
      addPassengerInfo(formValues).then(() => {
        this.loading = false
        this.$message.success('提交成功，正在跳转', () => {
          this.$router.push({
            path: '/extrafollow/book'
          })
        })
        // if (isDirectAccess) {
        //   this.$message.success('提交成功，正在下单', () => {
        //     this.handleToPayPage()
        //   })
        // } else {
        //   this.$message.success('提交成功，正在跳转', () => {
        //     this.$router.push({
        //       path: '/extrafollow/book'
        //     })
        //   })
        // }
      }).catch(err => {
        this.loading = false
        // NOTE: 未实名认证或者未注册金鹏会员统一弹窗校验逻辑
        this.handleSubmitReject(err)
      })
    },
    getPassengerCount (traveller) {
      const { adultDate, schoolChildrenDateRange = [] } = this
      let total = 0
      let adtCount = 0
      let guardianCount = 0
      let cnnCount = 0
      let preschoolCnnCount = 0
      let infCount = 0

      traveller.forEach(item => {
        total++
        if (item.passengerType === 'ADT') {
          adtCount++
          if (adultDate && moment(item.birthday).valueOf() <= adultDate.valueOf()) {
            guardianCount++
          }
        }
        if (item.passengerType === 'CHD') {
          cnnCount++
          if (schoolChildrenDateRange.length > 0 && moment(item.birthday).valueOf() >= schoolChildrenDateRange[0].valueOf() && moment(item.birthday).valueOf() < schoolChildrenDateRange[1].valueOf()) {
            preschoolCnnCount++
          }
        }
        if (item.passengerType === 'INF') {
          infCount++
        }
      })
      return { total, adtCount, guardianCount, cnnCount, infCount, preschoolCnnCount }
    },
    // 根据旅客姓名获取旅客信息
    getPassengerInfoByName (name) {
      let flag = false
      let formList = this.form.getFieldsValue().passengers
      for (let i = 0; i < formList.length; i++) {
        let c = formList[i]
        if (c.fullName === name) {
          flag = true
          return {
            fullName: c.fullName,
            certificateNo: c.certificateNo,
            certificateType: c.idType
          }
        }
      }
      if (!flag) {
        this.$message.error('婴儿携带人' + name + '不存在于表单中，请重新选择')
        return false
      }
    },
    /**
     * 获取成人旅客名单
     */
    getAdultList () {
      const { adultDate } = this
      const formList = this.form.getFieldValue('passengers')
      const adultOriginList = []
      const adultSelectedList = []

      for (let i = 0; i < formList.length; i++) {
        const c = formList[i]
        if (c.passengerType === 'ADT') {
          // 增加成年人大于18周岁过滤
          if (adultDate && moment(c.birthday).valueOf() <= adultDate.valueOf()) {
            adultOriginList.push(c.fullName)
          }
        } else if (c.passengerType === 'INF' && c.adultName) {
          adultSelectedList.push(c.adultName)
        }
      }

      // 筛出可选婴儿携带人
      this.adultOriginList = adultOriginList
      this.adultSelectedList = adultSelectedList
      this.adultList = _.difference(adultOriginList, adultSelectedList)
    },

    // 更新旅客证件类型
    onIdTypeChange (value, index, isManual = false) {
      const { usualPassengerList } = this
      const passenger = this.form.getFieldValue('passengers')?.[index] ?? {}
      if (passenger.id) {
        if (isManual) {
          this.$info({
            title: '温馨提示',
            content: '修改证件类型信息后，可能会读取相关常用乘机人信息，请注意您的旅客信息'
          })
        }
        const defaultPassengerCard = {
          'idType': value,
          'certificateNo': '',
          'issueCountry': undefined,
          'certExpried': null,
          'certExpriedObj': null
        }
        let currentPassengerItem = usualPassengerList.find(item => { return item.id === passenger.id })
        currentPassengerItem = { ...currentPassengerItem, ...passenger }
        let flag = false
        currentPassengerItem.passengerCards?.forEach(passengerCard => {
          if (passengerCard.idType === value) {
            const passengerCardClone = _.cloneDeep(passengerCard)
            passengerCardClone.certExpriedObj = passengerCardClone.certExpried ? moment(passengerCardClone.certExpried, 'YYYY-MM-DD') : ''
            delete passengerCardClone.id
            currentPassengerItem = { ...currentPassengerItem, ...passengerCardClone }
            flag = true
          }
        })
        if (!flag) {
          currentPassengerItem = { ...currentPassengerItem, ...defaultPassengerCard }
        }
        this.setPassengerField(index, currentPassengerItem)
      } else {
        this.$nextTick(() => {
          this.form.setFieldsValue({
            [`passengers[${index}].idType`]: value
          })
        })
      }
    },

    // onNationalityChange (value, index) {
    //   this.$info({
    //     title: '温馨提示',
    //     content: '修改国籍后，可能会影响旅客信息，请注意您的旅客信息'
    //   })
    //   if (!['CN', 'HK', 'TW', 'MO'].includes(value)) {
    //     this.$nextTick(() => {
    //       this.form.setFieldsValue({
    //         [`passengers[${index}].idType`]: undefined,
    //         [`passengers[${index}].certificateNo`]: ''
    //       })
    //     })
    //   }
    // },
    /**
     * 初始化联系人数据
     */
    initContactData () {
      let countryCode = '86'
      let mobile = this.user?.mobile || ''
      if (mobile.length > 11) {
        countryCode = mobile.slice(0, 2)
        mobile = mobile.slice(2)
      }
      this.form.setFieldsValue({
        [`customer.countryCode`]: countryCode,
        [`customer.fullName`]: this.user.chiName,
        [`customer.contactMobile`]: mobile,
        [`customer.email`]: this.user.email
      })
    },
    fillBirthday (idCard, index) {
      const birthObj = getBirthDay(idCard)
      const birthFormat = birthObj.birthFormat
      const birthday = birthObj.birthday
      if (this.isSpecial) {
        this.form.setFieldsValue({
          [`passengers[${index}].birthday`]: birthday
        })
      } else {
        this.form.setFieldsValue({
          [`passengers[${index}].birthdayObj`]: birthFormat,
          [`passengers[${index}].birthday`]: birthday
        })
      }
    },
    // 设置常用旅客
    setUsual (checked, index) {
      this.form.setFieldsValue({
        [`passengers[${index}].isUsual`]: checked
      })
    },
    // 设置邀请注册金鹏会员
    setInvite (checked, index) {
      this.form.setFieldsValue({
        [`passengers[${index}].isInvite`]: checked
      })
    },
    // 国际票通过 firstName 和 lastName 获取 fullName
    setFullName (item, index) {
      const { id, value } = item
      const { passengerFirstName = '', passengerLastName = '' } = this.form.getFieldsValue().passengers[index]
      let fullName = ''
      if (value && (passengerFirstName || passengerLastName)) {
        const regChinese = /^[\u2E80-\uFE4F]+$/
        if (regChinese.test(value) || regChinese.test(passengerFirstName) || regChinese.test(passengerLastName)) {
          fullName = id?.indexOf('passengerFirstName') >= 0 ? `${passengerLastName}${value}` : `${value}${passengerFirstName}`
        } else {
          const valueUpperCase = value.toLocaleUpperCase()
          fullName = id?.indexOf('passengerFirstName') >= 0 ? `${passengerLastName}/${valueUpperCase}` : `${valueUpperCase}/${passengerFirstName}`
        }
      }
      this.$nextTick(() => {
        this.form.setFieldsValue({
          [`passengers[${index}].fullName`]: fullName
        })
      })
    },
    // 增加一行旅客表单
    addPassenger (type) {
      const { forFormList = [], selectedCoupons, ifInternational, isSelfAirline } = this
      if (['JD', 'Y8'].includes(mainSettings.airline)) {
        const formList = this.form.getFieldValue('passengers')
        const hasChild = formList.findIndex(item => { return item.passengerType === 'CHD' }) >= 0
        const hasAudlt = formList.findIndex(item => { return item.passengerType === 'ADT' && item.certificateNo }) >= 0
        if (isSelfAirline && type === 'CHD' && !hasChild && hasAudlt) {
          this.$message.warn(`每名年满18周岁且具有完全民事行为能力的成人最多可带3名未满5岁的儿童（含1名婴儿）；携带5（含）至12岁（不含）以下儿童无数量限制。如同行的儿童为残疾儿童，则仅可携带一名残疾儿童出行，不能再携带其他儿童及婴儿旅客同行，详情可联系${getAppInfo()?.hotline}咨询。`)
        }
      }
      if (selectedCoupons.length) {
        if (forFormList.length > 0) {
          const h = this.$createElement
          this.$error({
            title: '温馨提示',
            content: h('div', {}, [
              h('p', '1. 您选择已使用优惠券，优惠券仅支持单人使用，如需继续添加乘机人，请先取消优惠券。'),
              h('p', '2. 该优惠券适用于年满12周岁以上乘客购票使用。')
            ])
          })
          return
        }
      }
      const valid = PassengerCountValidate(this.form.getFieldValue('passengers'), 'add', { passengerType: type }, this)
      if (valid.value) {
        const psg = {
          passengerType: type,
          idType: !ifInternational ? 'NI' : 'PP',
          isUsual: true,
          key: passengerIndex++
        }
        forFormList.push(psg)
        this.$nextTick(() => {
          const index = forFormList.length - 1
          this.form.setFieldsValue({
            [`passengers[${index}].passengerType`]: psg.passengerType,
            [`passengers[${index}].idType`]: psg.idType,
            [`passengers[${index}].isUsual`]: true
          })
          if (type === 'ADT' || type === 'CHD') {
            this.form.setFieldsValue({
              [`passengers[${index}].idType`]: 'NI'
            })
          }
          this.updatePassengerNum()
        }, 0)
        if (valid.warn) {
          this.$message.warn(valid.message)
        }
      } else {
        this.$message.error(valid.message)
      }
    },
    // 获取表单项所在的数组索引值
    getFieldIndex (filedName) {
      const sIndex = filedName.indexOf('[')
      const eIndex = filedName.indexOf(']')
      let index = filedName.slice(sIndex + 1, eIndex)
      index = parseInt(index)
      return index
    },
    /**
     * 更新购物车乘客数量
     */
    updatePassengerNum () {
      let adtCount = 0
      let cnnCount = 0
      let infCount = 0
      this.forFormList.forEach(psg => {
        if (psg.passengerType === 'ADT') {
          adtCount++
        }
        if (psg.passengerType === 'CHD') {
          cnnCount++
        }
        if (psg.passengerType === 'INF') {
          infCount++
        }
      })
      const passengers = []
      if (adtCount > 0) {
        let adtObj = {
          passengerType: 'ADT',
          passengerNum: adtCount
        }
        passengers.push(adtObj)
      }
      if (cnnCount > 0) {
        let cnnObj = {
          passengerType: 'CHD',
          passengerNum: cnnCount
        }
        passengers.push(cnnObj)
      }
      if (infCount > 0) {
        let infObj = {
          passengerType: 'INF',
          passengerNum: infCount
        }
        passengers.push(infObj)
      }
      const params = {
        modifyPassengers: passengers,
        shoppingCartId: this.cart.shoppingCartId
      }
      updatePassengerNum(params).then(result => {
        // 更新购物车
        this.cart = result
      }).catch(e => {
        this.$message.error(e.message)
      })
    },
    reSearch () {
      this.$router.go(-1)
    },
    // 优惠券相关
    async onCouponChange (value) {
      const { selectedCoupons, selectedCouponId } = this

      const { shoppingCartId, offers } = this.cart
      const offer = offers[0]
      const oldSelectedId = selectedCouponId

      if (value.length) {
        this.couponReady = 1
        // 添加优惠券
        this.selectedCouponId = value[0].couponNumber

        // 判断所选优惠券是否需实名本人下单使用
        const valid = await this.verifyOneSelf(value)
        if (!valid) {
          this.couponReady = 2
          this.selectedCouponId = ''
          return
        }
        const data = {
          shoppingCartId,
          discounts: [{
            couponNumber: value[0].couponNumber,
            couponType: 'TICKET',
            couponUseType: value[0].couponUseType,
            offerItemId: offer.detail.ticketCartItems[0].detail.offerItemId,
            serviceId: offer.detail.ticketCartItems[0].detail.serviceId
          }]
        }
        addCoupon(data).then(data => {
          this.cart = data
        }).catch(err => {
          this.$message.error(err.message || '网络异常，请稍后再试！')
          this.selectedCouponId = oldSelectedId
        }).finally(() => {
          this.couponReady = 2
        })
      }

      if (selectedCoupons.length && !value.length) {
        // 取消优惠券
        this.couponReady = 1
        this.selectedCouponId = ''
        const data = {
          offerItemId: offer.detail.ticketCartItems[0].detail.offerItemId,
          serviceId: offer.detail.ticketCartItems[0].detail.serviceId,
          shoppingCartId,
          type: 'TICKET'
        }
        removeCoupon(data).then(data => {
          this.cart = data
        }).catch(err => {
          this.$message.error(err.message || '网络异常，请稍后再试！')
          this.selectedCouponId = oldSelectedId
        }).finally(() => {
          this.couponReady = 2
        })
      }

      this.selectedCoupons = value
    },
    // 校验是否实名认证本人
    async verifyOneSelf (value) {
      // 这里必须触发一次视图更新，否则antdv form校验的时候就会报birthdayObj的值过期了，要重新校验
      this.loading = true
      // 是否已填写乘机人信息
      const valid = await this.validateForm()

      if (!valid) {
        this.$error({
          title: '温馨提示',
          content: '请完整填写乘客信息。'
        })
        this.loading = false
        return false
      }

      // 校验是否本人
      const values = this.form.getFieldsValue()
      const passenger = values.passengers[0]
      const { couponType, couponNumber } = value[0]

      try {
        const data = {
          fullName: passenger.fullName,
          certificateType: passenger.idType,
          certificateNo: passenger.certificateNo,
          couponType,
          couponNumber
        }
        await verifyOneself(data)
      } catch (err) {
        this.loading = false
        this.handleSubmitReject(err)
        return false
      }
      this.loading = false
      return true
    },
    handleSubmitReject (err) {
      const { message, code } = err
      if (['100010019', '100010026'].includes(code)) {
        this.$confirm({
          title: '温馨提示',
          content: message,
          okText: '去认证',
          cancelText: '取消',
          onOk: () => {
            this.loading = false
            mainSettings.router.push({
              pathname: '/micro/user/authenticate',
              query: { type: 'auth' }
            })
          },
          onCancel: () => {
            this.loading = false
          }
        })
      } else if (code === '100010020') {
        this.$confirm({
          title: '温馨提示',
          content: message,
          okText: '去完善',
          cancelText: '取消',
          onOk: () => {
            mainSettings.router.push({
              pathname: '/micro/user/account'
            })
          }
        })
      } else if (code === '100010040') {
        this.$confirm({
          title: '温馨提示',
          content: message,
          okText: '去注册',
          cancelText: '取消',
          onOk: () => {
            const href = `//ffp.hnair.com/FFPClub/member/register?lang=cn&ENROLLCHANNEL=${mainSettings.airline}WebSite`
            window.open(href, '_blank')
            // mainSettings.router.push({
            //   pathname: '/micro/user/ffp-binding'
            // })
          }
        })
      } else {
        this.$error({
          title: '温馨提示',
          content: message || '网络异常，请稍后再试！',
          okText: '知道了'
        })
      }
    },
    validateForm () {
      return new Promise((resolve) => {
        this.form.validateFields((err) => {
          if (err) {
            console.log('err >>>> ', err)
            resolve(false)
          } else {
            resolve(true)
          }
        })
      })
    },
    fetchCouponTicket () {
      const { couponReady, couponValid, cart } = this
      if (!couponValid.valid || couponReady !== 0) {
        return
      }

      this.couponReady = 1

      const data = {
        shoppingCartId: cart.shoppingCartId,
        airlineCode: cart.offers[0].detail.itinerarys[0].orgDsts[0].supplier, // 新增供应商入参用于判断是否返回优惠券
        couponType: 'TICKET'
      }
      queryCoupon(data).then(coupons => {
        this.couponReady = 2
        this.coupons = !_.isEmpty(coupons) ? coupons : []
      }).catch(err => {
        this.couponReady = 0
        this.$message.error(err.message || '网络异常，请稍后再试！')
      })
    },
    getCouponValid () {
      const { cart, forFormList, user } = this

      let valid = {
        valid: true,
        msg: '仅适用于机票订单为单人单航段使用'
      }

      if (userTypeMap[user.userType] === 'CARRIER' || userTypeMap[user.userType] === 'AGENT' || user.loginName === 'ETMOBILEUSER') {
        valid = {
          valid: false,
          msg: '不适用于当前用户类型'
        }
        return valid
      }

      if (cart && cart.offers.length > 1) {
        valid = {
          valid: false,
          msg: '仅适用于机票订单为单人单航段使用'
        }
        return valid
      }

      if (forFormList.length > 1) {
        valid = {
          valid: false,
          msg: '仅适用于机票订单为单人单航段使用'
        }
        return valid
      }

      return valid
    },
    // 卡券相关
    fetchCardList (isCheck) {
      if (isCheck) {
        this.queryCardCoupon()
      }
    },
    async queryCardCoupon () {
      this.loading = true
      const valid = await this.validateForm()
      if (!valid) {
        this.$error({
          title: '温馨提示',
          content: '请完整填写乘客信息。'
        })
        this.$refs.cards.show = false
        this.loading = false
        return false
      }
      const { shoppingCartId } = this.cart
      const passengerList = this.form.getFieldsValue().passengers || []
      passengerList.forEach((psg, index) => {
        passengerList[index].certificateType = psg.idType
        passengerList[index].icommPassenger = psg.isUsual
        delete passengerList[index].idType
        delete passengerList[index].isUsual
      })
      const params = {
        shoppingCartId,
        passengerList
      }
      this.cardReady = 1
      queryCardCoupon(params).then(result => {
        this.loading = false
        this.cardReady = 2
        this.cardCoupon = !_.isEmpty(result) ? result : {}
      }).catch(err => {
        this.loading = false
        this.cardReady = 0
        this.$refs.cards.show = false
        this.$message.error(err.message || '网络异常，请稍后再试！')
      })
    },
    async addCard (selectedCoupons) {
      const { cardCoupon } = this
      const { shoppingCartId } = this.cart
      const { couponCacheId } = cardCoupon
      const coupons = []
      if (selectedCoupons?.length > 0) {
        selectedCoupons.forEach(coupon => {
          coupons.push(coupon.couponCode)
        })
      }
      const params = {
        shoppingCartId,
        couponCacheId,
        coupons
      }
      this.cardReady = 1
      addCardCoupon(params).then(result => {
        this.cart = result
        const { cardCoupons, excludeCardCoupons } = result
        this.$message.success('操作成功')
        if (excludeCardCoupons?.length > 0 && cardCoupons?.length > 0) {
          const newCoupons = []
          for (let index = 0; index < cardCoupon.coupons.length; index++) {
            const coupon = cardCoupon.coupons[index]
            if (cardCoupons.find(cardCoupon => { return coupon.couponCode === cardCoupon.couponCode }) ||
            excludeCardCoupons.find(excludeCardCoupon => { return coupon.couponCode === excludeCardCoupon.couponCode && excludeCardCoupon.available })) {
              newCoupons.push(coupon)
            }
          }
          this.cardCoupon.coupons = newCoupons
        }
      }).catch(err => {
        this.$message.error(err.message || '网络异常，请稍后再试！')
      }).finally(() => {
        this.cardReady = 2
      })
    },
    onFormValuesChange (values) {
      // 旅客信息更新，重置卡券状态
      const { venusCouponEnable } = this
      if (venusCouponEnable && this.$refs.cards?.show) {
        this.$refs.cards.show = false
      }
    },
    async getCountryByApi () {
      this.oriDataList = await getCountry()
    },
    async fetchDictionaryListByApi () {
      const params = {
        'groupCode': 'PA',
        'parentCode': '0',
        'loadData': 'all',
        'dicTag': 'north-america'
      }
      this.dictionaryList = await fetchDictionaryList(params)
    },
    async handleToPayPage () {
      const { payUrl, ifInternational } = this
      const { shoppingCartId } = this.cart
      this.loading = true
      this.track.startPostTime = moment(new Date()).valueOf()
      try {
        let submitResult = await submitOrder({
          shoppingCartId,
          ifInternational
        })
        this.track.endPostTime = moment(new Date()).valueOf()

        // TODO: 注意测试覆盖
        if (submitResult.code === '100010001' && submitResult.extraInfo && submitResult.extraInfo.data) {
          submitResult = {
            success: true,
            data: submitResult.extraInfo.data
          }
        } else {
          submitResult = {
            success: true,
            data: submitResult
          }
        }

        // 清理下单流程使用到的storage
        storage.removeItem(`SHOPPINGCART_DATA`)
        storage.removeItem(`isJJC`)

        if (submitResult.success) {
          storage.setItem(`SUBMIT_RESULT`, submitResult, 0.5 * 3600000)
        }

        this.handleUniTrack()

        const query = {}
        if (ifInternational) {
          query.ifInternational = ifInternational
        }
        this.loading = false
        this.$router.push({
          path: payUrl,
          query
        })
      } catch (error) {
        const submitResult = {
          success: false,
          message: error.message
        }
        this.track.endPostTime = moment(new Date()).valueOf()
        this.handleUniTrack(error)

        const query = {}
        if (ifInternational) {
          query.ifInternational = ifInternational
        }

        // 清理下单流程使用到的storage
        storage.removeItem(`SHOPPINGCART_DATA`)
        storage.removeItem(`isJJC`)
        storage.setItem(`SUBMIT_RESULT`, submitResult, 0.5 * 3600000)
        this.loading = false
        this.$router.push({
          path: payUrl,
          query
        })
      }
    },
    handleUniTrack (error) {
      try {
        const { itinerarys = [], track } = this
        const { startPostTime, endPostTime } = track
        const postTime = ((endPostTime - startPostTime) / 1000).toFixed(2)
        if (postTime < 0) {
          return
        }
        const trackParams = {
          flight_org_code: itinerarys[0]?.orgDsts?.[0].departureCode,
          flight_dst_code: itinerarys[0]?.orgDsts?.[0].arrivalCode,
          order_inf_time: postTime,
          order_inf_time_decimal: postTime
        }
        if (error) {
          trackParams.inf_error_info = error.message
        }
        window.__MICRO_ROOT__?.api?.track?.('UNI_PlaceOrder', trackParams)
      } catch (error) {
        console.log('error >>>> ', error.message)
      }
    }
  },
  components: {
    PassengerItem,
    PassengerItemInt,
    SpecialPassenger,
    Contacts,
    Coupon,
    CardModule,
    FileUpload
  }
}
</script>
<style lang="less">
@import "style";
</style>
